import { ref, computed } from '@vue/composition-api'

export default function useQuizList(ctx) {
  const tableColumns = [
    { key: 'text', label: 'Question (EN)' },
    { key: 'text_ar', label: 'Question (AR)' },
    { key: 'updated_at', label: 'Updated At' },
    { key: 'actions', label: 'Actions' },
  ]

  const getQuestionsList = computed(() => ctx.root.$store.getters['learningCenterQuiz/getQuestionsList'])
  const questionsLoading = ref(false)

  const fetchQuestions = async () => {
    try {
      questionsLoading.value = true
      await ctx.root.$store.dispatch('learningCenterQuiz/fetchQuestions')
    } catch (error) {
      console.log(error)
    } finally {
      questionsLoading.value = false
    }
  }

  fetchQuestions()

  return {
    tableColumns,
    questionsLoading,
    fetchQuestions,
    getQuestionsList,
  }
}
